import React from "react";
import styles from "./styles";

import {
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import Context from "../../../../context";
import Cookies from "js-cookie";
import values from "../../../../values";
import utils from "../../../../utils";
import constants from "../../../../values/constants";
import DropDownLoading from "../../../../components/DropDownLoading";
import { ABSENT_STATUS } from "../../../../values/dropdownItems";
import "./index.scss";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // ========================================== JSX Content =============================================
  const { setShowModal, setSelectedAbsent } = React.useContext(
    Context.AbsentScreen
  );

  // function onClickCompany(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_COMPANY_INFORMATION");
  // }
  // function onClickManager(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_MANAGER_INFORMATION");
  // }
  // function onClickSuperAgent(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_SUPERAGENT_INFORMATION");
  // }

  // function onUpdate(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("UPDATE");
  // }

  // function onDelete(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("DELETE");
  // }
  function onApprove(service: any) {
    setSelectedAbsent(service);
    setShowModal("APPROVE");
  }

  const { t } = useTranslation();

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="company-table-body-container">
      {data?.map((absent: any, index: number) => {
        return (
          <tr
            key={`company-${index.toString()}`}
            className={`${absent?.service?.isChecked ? "unchecked" : ""}`}
          >
            <td
              className="pointer"
              // onClick={() => onClickCompany(absent)}
            >
              <UserInformation
                name={
                  absent?.student?.firstName + " " + absent?.student?.lastName
                }
                phoneNumber={
                  absent?.absentType === "STUDENT" ? t("student") : t("driver")
                }
              />
            </td>
            <td
              className="pointer"
              // onClick={() => onClickCompany(absent)}
            >
              <UserInformation
                name={
                  absent?.driver?.firstName + " " + absent?.driver?.lastName
                }
                phoneNumber={
                  absent?.absentType === "STUDENT" ? t("student") : t("driver")
                }
              />
            </td>
            <td>
              {utils.convertGregorianToJalali({
                format: "hh:mm - jYYYY/jMM/jDD",
                date: absent?.createdAt,
              })}
            </td>
            <td>
              {utils.convertGregorianToJalali({
                format: "hh:mm - jYYYY/jMM/jDD",
                date: absent?.updatedAt,
              })}
            </td>
            <td
              className="pointer"
              // onClick={() => onClickManager(absent)}
            >
              {absent?.statusInService &&
                t(
                  ABSENT_STATUS?.find(
                    (item) => item.value === absent?.statusInService
                  )?.name as string
                )}
            </td>
            <td
              className="pointer"
              // onClick={() => onClickManager(absent)}
            >
              {absent?.absentType === "STUDENT" && t("The_student_is_absent")}
              {absent?.absentType === "DRIVER" && t("The_driver_is_absent")}
            </td>
            {/* <td>
              <CustomBadges title={company?.superAgentInformation?.city} type="primary" />
            </td> */}
            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* Approve Icon */}
                {/* {
                  <CustomIcon
                    icon="fas fa-check"
                    hoverTitle="چک کردن"
                    onClick={() => onApprove(absent)}
                  />
                } */}
                {/* Edit Icon */}
                {/* {absent?.service?.isChecked && ( */}
                <CustomIcon
                  icon="fas fa-check"
                  hoverTitle={t("changeStatus")}
                  onClick={() => {
                    setSelectedAbsent(absent);
                    setShowModal("UPDATE");
                  }}
                />
                {/* )} */}
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
